import { render, staticRenderFns } from "./WaybillInfo.vue?vue&type=template&id=29f61dd6&"
import script from "./WaybillInfo.vue?vue&type=script&lang=js&"
export * from "./WaybillInfo.vue?vue&type=script&lang=js&"
import style0 from "./WaybillInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports